import CallToAction from "components/CallToAction"
import { TeamMember, TeamMemberModal } from "components/TeamMember"
import { getStoryblokLink } from "utilities/getStoryblokLink"
import richText from "utilities/richText"

export default function FeaturedTeamMember({ blok }) {
  return (
    <>
      <TeamMemberModal {...blok.teamMember} />
      <section className="relative isolate bg-springWood px-6 py-16">
        <div className="featured-team-member mx-auto max-w-screen-xl">
          <h2 className="-mb-4 text-center text-teal-dark lg:-mb-0">{blok.heading}</h2>
          <TeamMember {...blok.teamMember} />
          <div className="featured-team-member-content pt-5">
            <div className="bg-white px-11 py-10 shadow">{richText(blok.content)}</div>
            <div className="text-center">
              <CallToAction href={getStoryblokLink(blok.link)} style="tertiary" className="block mx-auto mt-6">
                {blok.link_label}
              </CallToAction>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
